import { memo } from "react";

import HelpIcon from "@/components/ui/icon/help";
import { Image } from "@/components/ui/image/image";

import type { ReferenceArticle } from "../types";

type ArticleCardProps = {
	article: ReferenceArticle;
};

export const ArticleCard = memo(({ article }: ArticleCardProps) => {
	return (
		<a
			href={article.url}
			target="_blank"
			rel="noopener noreferrer"
			className="block max-w-96 space-y-4 rounded-lg p-3 ring-1 ring-zinc-200 transition-shadow hover:ring-2 hover:ring-zinc-950"
		>
			{article.thumbnailUrl ? (
				<Image
					src={article.thumbnailUrl}
					alt={article.title}
					className="h-32 w-full rounded object-cover"
					loading="lazy"
				/>
			) : (
				<div className="border-gray-200 flex h-32 items-center justify-center rounded-lg border p-4">
					{article.iconComponent ? (
						<article.iconComponent className="size-16" />
					) : (
						<HelpIcon className="size-16" />
					)}
				</div>
			)}
			<h4 className="text-gray-900 line-clamp-5 text-sm font-medium">{article.title}</h4>
		</a>
	);
});

ArticleCard.displayName = "ArticleCard";
